import React, { Component } from "react";
import { connect } from "react-redux";
import {finishApplication, nextStep} from '../../actions';
import PropTypes from "prop-types";
import Frame from "../Frame";
import {createStructuredSelector} from 'reselect';
import {
  appRequestSelector,
} from '../../selectors';
import consumer from '../../../../cable';
import {BlueBtn} from "../../../../components/Controls";

class CreditkeyContract extends Component {
  receiveMessage = (event) => {
    return;
  }

  constructor(props) {
    super(props);
    this.state = {
      submitLoading: false,
      contractUrl: null,
    };
    this.blobUrl = null;
  }

  finish = async () => {
    this.setState({ submitLoading: true });
    const { finishApplication } = this.props;
    finishApplication();
  };

  componentDidMount() {
    const { agreement } = this.props;
    if (agreement instanceof Blob) {
      this.blobUrl = URL.createObjectURL(agreement);
      this.setState({ contractUrl: this.blobUrl });
    } else {
      console.error('Expected Blob in props.agreement but got:', agreement);
    }
  }

  componentWillUnmount() {
    if (this.blobUrl) {
      URL.revokeObjectURL(this.blobUrl);
    }
  }

  render() {
    const { hidden } = this.props;
    const { contractUrl, submitLoading } = this.state;

    return (
      <div>
        <Frame
          contractUrl={contractUrl || ''}
          hidden={hidden}
          onReceiveMessage={this.receiveMessage}
        />
        <BlueBtn
          onClick={this.finish}
          loading={submitLoading}
          disabled={submitLoading}
        >
          SIGN AGREEMENT
        </BlueBtn>
      </div>
    );
  }
}

CreditkeyContract.propTypes = {
  contractUrl: PropTypes.string,
};

CreditkeyContract.defaultProps = {
  contractUrl: "",
};

const mapStateToProps = createStructuredSelector({
  appRequest: appRequestSelector()
});

const mapDispatchToProps = (dispatch) => ({
  finishApplication: () => dispatch(finishApplication()),
  nextStep: value => dispatch(nextStep(value))
});

export default connect(mapStateToProps, mapDispatchToProps)(CreditkeyContract);
